module.exports = __webpack_public_path__ + "files/7da9f4ff91997b332f75fd6b5d25f8df.svg";